export const PRIOR_YEAR = 'PRIOR_YEAR';
export const PRIOR_PERIOD = 'PRIOR_PERIOD';